import * as THREE from 'three';

export interface Placement {
  /** The part's footprint centred on the origin. */
  centre: boolean;
  /** The part's lowest point on the floor. */
  sit: boolean;
}

/** How far to move a part with bounds `box` (as the file placed it) for this placement. */
export function placementOffset(box: THREE.Box3, { centre, sit }: Placement, target: THREE.Vector3): THREE.Vector3 {
  target.set(0, 0, 0);
  if (box.isEmpty()) return target;
  if (centre) {
    const center = box.getCenter(new THREE.Vector3());
    target.x = -center.x;
    target.y = -center.y;
  }
  if (sit) target.z = -box.min.z;
  return target;
}
